<template>
  <div :id="id" class="dropzone"></div>
</template>

<script>
// CP4.4: vue2-dropzone (Vue 2 only) -> a thin wrapper over dropzone@6. Reimplements the subset of the
// vue2-dropzone <vue-dropzone> API the app uses: props id/options; events vdropzone-files-added / -sending /
// -success / -error; exposed `dropzone` instance + removeAllFiles(). NOTE: the AWS-signed upload flow
// (DocumentDialog/FileImport) must be re-verified at runtime — see Phase-4 QA.
import { markRaw } from 'vue'
import { Dropzone } from 'dropzone'
import 'dropzone/dist/dropzone.css'

export default {
  name: 'VueDropzone',
  props: {
    id: { type: String, required: true },
    options: { type: Object, required: true }
  },
  data () {
    return {
      dropzone: null
    }
  },
  mounted () {
    // v6 auto-discovery is off for manually-constructed instances.
    Dropzone.autoDiscover = false
    // markRaw: Dropzone does identity ops on its own files[]/options; a reactive Proxy breaks indexOf/splice.
    this.dropzone = markRaw(new Dropzone(this.$el, { ...this.options }))
    this.dropzone.on('addedfiles', (files) => this.$emit('vdropzone-files-added', files))
    this.dropzone.on('sending', (file, xhr, formData) => this.$emit('vdropzone-sending', file, xhr, formData))
    this.dropzone.on('success', (file, response) => this.$emit('vdropzone-success', file, response))
    this.dropzone.on('error', (file, message, xhr) => this.$emit('vdropzone-error', file, message, xhr))
  },
  beforeUnmount () {
    if (this.dropzone) {
      this.dropzone.destroy()
      this.dropzone = null
    }
  },
  methods: {
    removeAllFiles (cancelIfNecessary = false) {
      if (this.dropzone) this.dropzone.removeAllFiles(cancelIfNecessary)
    },
    removeFile (file) {
      if (this.dropzone) this.dropzone.removeFile(file)
    },
    processQueue () {
      if (this.dropzone) this.dropzone.processQueue()
    }
  }
}
</script>
